import { useEffect } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import MyCKEditor from "src/components/common/myCKEditor";
import { useMyStore } from "src/components/main/mainStore";
import { myAxios, MyFormData } from "src/components/common/functions";
export default function Form({
    keyword, 
    handleSubmit, 
    closeIt, 
    curId, 
    doc, 
    curData, 
    setData, 
    curFile, 
    setFile, 
    parentFolder
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    useEffect(() => {
        let isMounted = true;
        if(keyword ===  "Add"){
            return;
        }
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("fileId[]", curId);
            //-----------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("common/getFile.php", formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //-----------------------------------------------------------
            setData(res.data);
            setFile(doc);
        }
        getData();
        return () => {isMounted = false};
    }, [keyword, curId, doc])
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            max
            closeIt = {closeIt}
            title = {user.newspaper === "yes"?keyword:curFile.name}
            width = {"900px"}
            handleFormSubmit = {handleSubmit}
            actionKey = {user.newspaper === "yes"?keyword:null}
        >
            <div className = "my-3">
                {user.newspaper === "yes"?
                <>
                    <input className = "nodisplay" readOnly name = "parentFolderId" value = {parentFolder[parentFolder.length - 1].id || ""}/>
                    <input className = "nodisplay" readOnly name = "fileId" value = {curFile.id}/>
                    <input className = "nodisplay" readOnly name = "data" value = {curData}/>
                    <div className = "my-3 d-flex align-items-center">
                        <span className = "mr-3 font-weight-bold">Title</span>
                        <input required className = "form-control d-block flex-grow-1" name = "subject" defaultValue = {curFile.name}/>
                    </div>
                </>
                :null}
                <MyCKEditor
                    data = {curData}
                    onChange = {(e, editor) => {
                        setData(editor.getData()); 
                    }}
                    disabled = {user.newspaper === "no"}
                />
            </div>
        </Modal>
    )
}